import { VeltCommentThread , VeltComments, VeltCommentTool,VeltViewAnalytics, useCommentAnnotations, useSetDocumentId} from '@veltdev/react';
import './CommentThreadPage.css';

function CommentThreadPageError() {

    useSetDocumentId("comment-thread-demo")
    let commentAnnotations = useCommentAnnotations("comment-thread-demo") 
    console.log(commentAnnotations)

    return (
        <div id="huddleContainer">
            <div className="huddle-main-view">
                <div className='huddle-tools-container'>
                {commentAnnotations?.slice(0,2).map( (x,i) => <div key={i}>{x.annotationId}</div>)}  

                    {commentAnnotations?.slice(0,2).map( (x,i) => <VeltCommentThread key={i} annotationId={x.annotationId}/>)}  
                </div>
            </div>
        </div>
    )
}

export default CommentThreadPageError;